export default {
  clueListData: {},
  allSalesman: [],
  detail: {},
  searchCustomerList: [],
  transferDetail: {},
  clueVisit: {},
};
